import {LiveDashboard} from "@common/ui-components/live/live-dashboard/live-dashboard";
import collection from "./kpi-colors-collection.json";
import data from "./kpi-colors-data.json";

export const KpiColorsThemeAuto = (props) => {
    return LiveDashboard({
        collection,
        defaultData: data,
        disabledTileActions: true,
        ...props,
    });
};
